import { useQueryModel } from '@obtainly/http';
export function usePriceReadByDistributor(data) {
    return useQueryModel('price.read_by_distributor', data);
}
